(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/models/login.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/models/login.js');

'use strict';

svs.player_login.models.Login = Backbone.Model.extend({
  defaults: {
    ssn: undefined,
    returnUrl: undefined,
    loginToken: undefined,
    action: undefined,
    isCustomerRegistration: false,
    isSsnFallback: false,
    useragent_family: '',
    isReturnUrlSafe: false,
    startBankId: false,
    returnNewCustomer: false,
    newCustomerLogin: undefined,
    isPoker: false,
    lastLoginTime: undefined,
    rememberChecked: false
  },
  initialize() {
    this.set('ssn', svs.components.Storage.browser.get('ssn', 'customer_login'));
    const rememberCheck = svs.components.Storage.browser.get('rememberMe', 'customer_login');
    this.set('rememberChecked', rememberCheck !== undefined ? rememberCheck : false);
  },
  toQueryString() {
    let targetPath = window.location.search;
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'returnUrl', encodeURIComponent(this.get('returnUrl') || '/'));
    if (this.get('isReturnUrlSafe')) {
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'w', 't');
    }
    if (this.get('isPoker')) {
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'client', 'poker');
    }
    if (this.get('returnNewCustomer')) {
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'rnc', 'true');
    }
    return targetPath.substring(1);
  }
});

 })(window);